var React = require('react');

function Contact (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"16.53 3.24 16.53 15.33 12.72 13 1.48 13 1.47 12.99 1.47 3.24 16.53 3.24"}));
}

Contact.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Contact;

Contact.default = Contact;
